function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var LSCart = {
  items: [],
  subTotal: 0,
  tax: 0,
  taxch: 0,
  total: 0,
  discount: 0,
  $el: null,
  $itemTpl: null,
  $fixedCartTpl: null,
  $optionsContainer: null,
  COOKIE_KEY: 'lscart',
  isFixedCartRendered: false,
  isFreeCartAllowed: false,
  isFreeAllowed: false,
  productsForceCartReload: ['Registered Office'],
  onRenderEvents: [],
  initialize: function initialize(options) {
    this.$el = options.$el;
    // tpl is duplicated in the DOM, cart is at multiple places
    // so we end up with multiple tpl chained together
    this.$itemTpl = $(options.$itemTpl[0]);
    this.$fixedCartTpl = $($('.templates .fixed-cart')[0]);
    this.$optionsContainer = options.$optionsContainer;
    this.isFreeAllowed = options.isFreeAllowed ? options.isFreeAllowed : false;

    // no need to get a potentially outdated version of the product
    // const cartItems = LSUtils.localStorage.getItem(this.COOKIE_KEY);
    var cartItems = null;
    if (cartItems !== null && cartItems !== void 0 && cartItems.length && cartItems[0].name === clientData.product.name && !this.productsForceCartReload.includes(clientData.product.name)) this.items = cartItems;else {
      var _clientData$product;
      if (!((_clientData$product = clientData.product) !== null && _clientData$product !== void 0 && (_clientData$product = _clientData$product.cartViewPackages) !== null && _clientData$product !== void 0 && _clientData$product.active) && (clientData.product.price || clientData.product.isSubscription && !clientData.product.packages)) {
        this.items = [clientData.product];
        LSUtils.localStorage.setItem(this.COOKIE_KEY, this.items);
      }
    }
    this.render();
    this.bind();
    var self = this;
    setTimeout(function () {
      // call show plans after binding LSCheckout.initAddonButtons has been called
      if (clientData.product.isSubscription && !clientData.product.packages) self.showPlans(clientData.product);
    }, 500);
  },
  bind: function bind() {
    $(document).on('click', '.cart-view-all', function () {
      var $btn = $(this);
      var $product = $btn.closest('.product-description');
      $('.cart-product-item-collapsible', $product).toArray().forEach(function (e) {
        $(e).toggle();
      });
      if ($btn.text().includes('all')) {
        $btn.html('<i class="fa fa-angle-down" style="line-height: 29px;"></i> view less');
      } else {
        $btn.html('<i class="fa fa-angle-right"></i> view all features...');
      }
      return false;
    });
    //Bind to remove x icon
    $(document).on('click', '.item-remove', function () {
      LSCart.removeItemFromCart($(this).data('optionType'), $(this).data('optionId'), $(this).data('cartOnly'));
    });
  },
  removeItemFromCart: function removeItemFromCart(itemType, itemId) {
    var cartOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    //Get the item to remove based on type & id / parent for plans
    var itemToRemove = this.items.find(function (item) {
      return (item.id === itemId || item.parent === itemId) && item.type === itemType;
    });
    var pathName = window.location.pathname.replace('/checkout/', '/product/');
    var redirectUrl = pathName + window.location.search;
    if (redirectUrl.includes('/checkout?') && window.location.search) redirectUrl = redirectUrl.replace('/checkout', '/product');
    if (!itemToRemove.type) {
      //e.g. SA, VAT, PAYE send them to product landing page
      window.history.pushState("", document.title, redirectUrl);
      window.location.href = redirectUrl;
    } else if (itemToRemove.type === 'package') {
      if (!cartOnly) {
        //Send them back to pkg selection
        window.history.pushState(null, null, '#' + 0);
        $(window).trigger('hashchange');
      } else {
        $(".cart-package-choice-btn[data-option-id='".concat(itemId, "'][data-option-type='").concat(itemType, "']")).text('Select').removeClass('btn-package-selected');
      }
      this.removePackage(itemId);
    } else if (itemToRemove.type === 'plan') {
      //This will trigger the button click to remove the plan based on the item id (parent e.g. registered-office-custom
      $('.btn-addon[data-option-id="' + itemId + '"]').trigger('click');
      this.removeItem(itemId);
    } else if (itemToRemove.type === 'addon') {
      var queryString = clientData.queryString;
      var isMainProductOption = queryString.optionId === itemToRemove.id && parseInt(queryString.rank) === 1;
      if (isMainProductOption) {
        window.history.pushState("", document.title, redirectUrl);
        window.location.href = redirectUrl;
      } else {
        //This will trigger the button click to remove the addon based on the item id
        $('.btn-addon[data-option-id="' + itemId + '"]').trigger('click');
        this.removeItem(itemId);
      }
    }
    this.render();
  },
  render: function render() {
    var _this = this,
      _this$items,
      _this$items2;
    var self = this;
    this.subTotal = 0;
    this.tax = 0;
    this.taxch = 0;
    this.total = 0;
    this.discount = 0;
    if (clientData.product.useRealCHFees) {
      var _clientData$product$n;
      this.taxch = (_clientData$product$n = clientData.product.nonTaxableAmount) !== null && _clientData$product$n !== void 0 ? _clientData$product$n : 0;
    }
    $('.card-body', self.$el).empty();
    var cisReg = clientData && clientData.product && clientData.product.name === "CIS Registration Service";
    // if(cisReg){
    //     const $info = self.$itemTpl.clone();
    //     $('.product-price', $info).parent().remove();
    //     $('.product-description', $info).html("Upon submitting your payment, you will be directed to our simplified online questionnaire to register for CIS.");
    //     $('.card-body', self.$el).append($info);
    // }
    var disso = clientData && clientData.product && clientData.product.name === "Dissolution";
    if (disso && !LSCart.items.length) {
      $('.cart-left-side .container-add-ons').css('display', 'none');
    } else if (disso && LSCart.items.length) {
      $('.cart-left-side .container-add-ons').css('display', 'block');
      $('.cart-left-side .container-add-ons .custom-card-body').css('display', 'flex');
    }
    var dissoAddonNotHidden = false;
    var dissoAddons = $('.cart-left-side .container-add-ons > div').filter(function () {
      if (this.style.display !== 'none') dissoAddonNotHidden = true;
      return this.style.display == 'block';
    });
    if (disso && (!LSCart.items.length || !dissoAddonNotHidden)) {
      $('.packages-title').css('display', 'none');
    } else if (disso && LSCart.items.length && dissoAddonNotHidden) {
      $('.packages-title').css('display', 'block');
    }
    var nonTaxMutEx = false;
    //No. of items in the cart for digit icon
    $('.icon-container .circle').text(this.items.length);
    if (this.items.length) this.items.forEach(function (i, index) {
      var _i$stripe, _i$stripe2;
      var $item = self.$itemTpl.clone();
      var $name = $('<div class="ellipsis-line-2"></div>');
      if (clientData.product.useRealCHFees && i.nonTaxableAmount && (i.type === 'addon' || i.type === 'package')) if (!i.nonTaxMutEx || !nonTaxMutEx) _this.taxch += i.nonTaxableAmount;
      if (i.nonTaxMutEx && !nonTaxMutEx) nonTaxMutEx = true;
      if (!((_i$stripe = i.stripe) !== null && _i$stripe !== void 0 && _i$stripe.plans)) {
        // item is a product w/o a subscription
        if (i.discount) {
          $('.container-product-price', $item).hide();
          $('.container-product-price-discount', $item).show();
          $('.container-product-price-discount .container-product-price', $item).show();
          $('.product-og-price', $item).html(i.discount.ogPrice);
          $('.product-discount-text', $item).html(i.discount.text);
        }
        if (i.type === 'bundle') {
          $('.bundle-remove', $item).show();
        }
        $('.product-price', $item).html(i.price.toFixed(2));
      } else {
        // item is a product w/ a subscription
        $('.product-price', $item).parent().remove();
      }
      if (i.type !== 'plan') {
        var _i$cart$name, _i$cart, _i$cart$description, _i$cart2;
        // item is not a plan
        var name = (_i$cart$name = (_i$cart = i.cart) === null || _i$cart === void 0 ? void 0 : _i$cart.name) !== null && _i$cart$name !== void 0 ? _i$cart$name : i.name;
        var description = (_i$cart$description = (_i$cart2 = i.cart) === null || _i$cart2 === void 0 ? void 0 : _i$cart2.description) !== null && _i$cart$description !== void 0 ? _i$cart$description : i.description;
        $('.product-description', $item).html(description);
        $name.html(name);
      } else {
        var _clientData$product2;
        // item is a plan
        if ((_clientData$product2 = clientData.product) !== null && _clientData$product2 !== void 0 && (_clientData$product2 = _clientData$product2.stripe) !== null && _clientData$product2 !== void 0 && _clientData$product2.plans) {
          var _clientData$product3;
          // tlp product w/ subscription (reg off)
          var plans = (_clientData$product3 = clientData.product) === null || _clientData$product3 === void 0 || (_clientData$product3 = _clientData$product3.stripe) === null || _clientData$product3 === void 0 ? void 0 : _clientData$product3.plans;
          var $span = $('<span class="semi-bold">' + i.name.toUpperCase() + '<br /></span>');
          $name.append($span);
          $name.append('<span>Plan: </span>');
          var _iterator = _createForOfIteratorHelper(plans),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var p = _step.value;
              if (p.id === i.id) {
                // const $a = $('<a href="#" style="font-weight: normal;" class="text-sm">' + p.title + '&nbsp;</a>');
                // $a.bind('click', () => {
                //     $('[data-option-id="' + p.id + '"]').click();
                //     return false;
                // });
                $name.append('<span class="text-success">' + p.title + '</span>');
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          var _i$cart$name2, _i$cart3, _i$cart$description2, _i$cart4;
          // addon w/ subscription (ltd + reg off addon)
          var _name = (_i$cart$name2 = (_i$cart3 = i.cart) === null || _i$cart3 === void 0 ? void 0 : _i$cart3.name) !== null && _i$cart$name2 !== void 0 ? _i$cart$name2 : i.name;
          var _$span = $('<span>' + _name + '</span>');
          $name.append(_$span);
          var plan = '<div class="text-sm ellipsis mb-2">Plan: <span class="text-success semi-bold">' + i.id.toUpperCase() + '</span></div>';
          var _description = plan + ((_i$cart$description2 = (_i$cart4 = i.cart) === null || _i$cart4 === void 0 ? void 0 : _i$cart4.description) !== null && _i$cart$description2 !== void 0 ? _i$cart$description2 : i.description);
          $('.product-description', $item).html(_description);
        }
      }
      $('.product-name', $item).append($name);
      //Id can be either parent or id depending on if it is a plan or not
      //Add the item id & type to remove (x) icon
      if (i.type === 'plan') {
        $('.item-remove', $item).attr('data-option-id', i.parent);
      } else {
        $('.item-remove', $item).attr('data-option-id', i.id);
      }
      $('.item-remove', $item).attr('data-option-type', i.type);
      if (i.cartPackage) $('.item-remove', $item).attr('data-cart-only', true);
      $('.item-remove', $item).show();
      if (i.disclaimer && !((_i$stripe2 = i.stripe) !== null && _i$stripe2 !== void 0 && _i$stripe2.plans)) $('.product-description', $item).append($('<div class="alert alert-warning" style="margin-left: -15px; margin-right: -15px;margin-bottom: 25px;">' + i.disclaimer + '</div>'));
      if (i.basketWarning && _this.items.length === 1) $('.product-description', $item).append($('<div class="alert alert-danger" style="margin-left: -15px; margin-right: -15px;margin-bottom: 25px;"><b>' + i.basketWarning + '</b></div>'));
      $('.card-body', self.$el).append($item);
      self.subTotal += i.price ? i.price : 0;
      self.tax += (i.price ? i.price : 0) * 0.2;
      self.total = self.subTotal + self.tax + self.taxch;
      if (i.discount) {
        self.discount += i.discount.ogPrice - i.price;
      }
    });else {
      var $item = self.$itemTpl.clone();
      $('.product-price', $item).parent().remove();
      $('.product-description', $item).html('Your cart is currently empty, please add a service from the list below...');
      $('.card-body', self.$el).append($item);
    }
    if (this.discount) {
      $('.container-subtotal', this.$el).hide();
      $('.container-subtotal-discount', this.$el).show();
      $('.container-subtotal-discount', this.$el).closest('.mb-2').css('height', '32px');
      $('.sub-total-og-value', this.$el).html((this.subTotal + this.discount).toFixed(2));
    }
    $('.subTotal', this.$el).html(this.subTotal.toFixed(2));
    $('.tax', this.$el).html(this.tax.toFixed(2));
    $('.tax-ch', this.$el).html(this.taxch.toFixed(2));
    $('.total', this.$el).html(this.total.toFixed(2));
    if (this.isFreeAllowed) {
      this.toggleGoToCheckoutOrDashboardBtn();
    } else if ((this === null || this === void 0 || (_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) === 1 && this !== null && this !== void 0 && (_this$items2 = this.items) !== null && _this$items2 !== void 0 && (_this$items2 = _this$items2[0]) !== null && _this$items2 !== void 0 && _this$items2.basketWarning) {
      // Check for change checkout if only RO is in the basket, then checkout button should be disabled
      $('.btn-continue, .btn-pay', this.$el).prop('disabled', true);
    } else {
      $('.btn-continue, .btn-pay', this.$el).prop('disabled', this.total === 0);
    }
    LSUtils.localStorage.setItem(this.COOKIE_KEY, this.items);
    LSCheckout.setGlideHeight();
    var _iterator2 = _createForOfIteratorHelper(this.onRenderEvents),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var ev = _step2.value;
        ev();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if ('[data-toggle="popover"]', this.$el) LSCMSUtils.initPopovers();
  },
  removeFixedCart: function removeFixedCart() {
    this.$fixedCartTpl.remove();
  },
  renderFixedCart: function renderFixedCart(stepId) {
    var self = this;
    var $header = $('#container-header');
    var $stepper = $('#stepper-desktop');
    if (stepId === 'cart') {
      $('.btn-continue', this.$fixedCartTpl).show();
      $('.btn-pay', this.$fixedCartTpl).hide();
    } else {
      $('.btn-pay', this.$fixedCartTpl).show();
      $('.btn-continue', this.$fixedCartTpl).hide();
      $('.btn-loader', this.$fixedCartTpl).toArray().map(function (e) {
        LSCheckout.submitButtons.push(Ladda.create(e));
      });
    }
    $('#container-main').append(this.$fixedCartTpl);
    var posX_width = function posX_width() {
      // in case we switch from mobile to desktop
      var $cart = self.getCurrentlyVisibleCart();
      if (!$cart) return;
      self.$fixedCartTpl.width($cart.width());
      var right = window.innerWidth < 768 ? 15 : window.innerWidth - ($cart.offset().left + $cart.width()) - 1;
      // self.$fixedCartTpl.css('right', (right + 15) + 'px');
      self.$fixedCartTpl.css('right', right + 'px');
    };
    var posY = function posY() {
      // in case we switch from mobile to desktop
      // const $cart = $('#' + stepId + ' .cart:visible');
      var $cart = self.getCurrentlyVisibleCart();
      if (!$cart) return;
      var fixedCartHeight = window.innerWidth < 768 ? 295 : 518;
      var marginHeight = window.innerWidth < 768 ? 75 : 15;
      var headerHeight = $header.height();
      var stepperHeight = $stepper.length > 0 ? $stepper.height() : 42;
      var yThreshold = $cart.offset().top + $cart.height() - fixedCartHeight + headerHeight + stepperHeight + marginHeight;
      if ($(window).scrollTop() >= yThreshold) {
        self.$fixedCartTpl.show();
        self.toggleGoToCheckoutOrDashboardBtn();
      } else self.$fixedCartTpl.hide();
    };
    posX_width();
    posY();
    if (!this.isFixedCartRendered) {
      this.isFixedCartRendered = true;
      $(window).bind('resize', function () {
        posX_width();
      });
      $(window).bind('scroll', function () {
        posY();
      });
    }
  },
  getCurrentlyVisibleCart: function getCurrentlyVisibleCart() {
    var $visibleCarts = $('.cart:visible');
    for (var i = 0; i < $visibleCarts.length; i++) {
      if ($($visibleCarts[i]).offset().left >= 0 && $($visibleCarts[i]).offset().left <= window.innerWidth) return $($visibleCarts[i]);
    }
    return null;
  },
  addItem: function addItem(itemJson) {
    this.items.push(itemJson);
  },
  removeItem: function removeItem(id) {
    this.items = this.items.filter(function (item) {
      return item.id !== id;
    });
  },
  addPackage: function addPackage(id) {
    var _selectedPkg$cart$nam, _selectedPkg$cart, _clientData$product$c, _selectedPkg$cart2;
    this.removePackage(id);
    var selectedPkg = clientData.product.packages.filter(function (item) {
      return item.id === id;
    })[0];
    var itemJson = {
      type: 'package',
      id: id,
      name: (_selectedPkg$cart$nam = selectedPkg === null || selectedPkg === void 0 || (_selectedPkg$cart = selectedPkg.cart) === null || _selectedPkg$cart === void 0 ? void 0 : _selectedPkg$cart.name) !== null && _selectedPkg$cart$nam !== void 0 ? _selectedPkg$cart$nam : clientData.product.name,
      price: selectedPkg.price,
      description: [],
      disclaimer: selectedPkg.disclaimer ? selectedPkg.disclaimer : null,
      stripe: selectedPkg.stripe ? selectedPkg.stripe : null,
      cartPackage: !!((_clientData$product$c = clientData.product.cartViewPackages) !== null && _clientData$product$c !== void 0 && _clientData$product$c.active)
    };
    if (selectedPkg.nonTaxableAmount) itemJson.nonTaxableAmount = selectedPkg.nonTaxableAmount;
    if (selectedPkg !== null && selectedPkg !== void 0 && (_selectedPkg$cart2 = selectedPkg.cart) !== null && _selectedPkg$cart2 !== void 0 && _selectedPkg$cart2.description) {
      itemJson.description = "<div class=\"ellipsis-line-2 mt-1\" style=\"line-height: 22px;\">" + selectedPkg.cart.description + "</div>";
    } else {
      var pkgTitle = 'Package: <span class="text-success semi-bold">' + selectedPkg.shortName.toUpperCase() + '</span>';
      if (selectedPkg.bundles) {
        pkgTitle += '<div class="ellipsis mt-1" style="line-height: 22px;">';
        var _iterator3 = _createForOfIteratorHelper(selectedPkg.description.filter(function (e, i) {
            return i < 5;
          })),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var d = _step3.value;
            pkgTitle += '- ' + d + '<br />';
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        pkgTitle += '</div>';
      }
      itemJson.description.push('<div class="text-sm ellipsis mb-2">' + pkgTitle + '</div>');
      var maxRows = 4;
      selectedPkg.options.forEach(function (o, i) {
        var mt = i === 0 ? 'mt-3' : '';
        if (i === maxRows) itemJson.description.push('<div class="text-sm ellipsis mb-2"><a class="cart-view-all" href="#"><i class="fa fa-angle-right"></i> view all features...</a></div>');
        var optionJson = clientData.product.options.filter(function (item) {
          return item.id === o;
        })[0];
        if (optionJson) {
          itemJson.description.push('<div class="cart-product-item text-sm ellipsis mb-2 ' + mt + ' ' + (i >= maxRows ? 'cart-product-item-collapsible' : '') + '" style="' + (i >= maxRows ? 'display: none' : '') + '" data-toggle="tooltip" title="' + optionJson.title.replaceAll("\"", "'") + '"><i class="fa fa-circle" style="font-size: 4px;vertical-align: middle;"></i> ' + optionJson.title + '</div>');
          if (!itemJson.disclaimer && optionJson.disclaimer) itemJson.disclaimer = optionJson.disclaimer;
        }
      });
    }
    // if (selectedPkg.options.length >= maxRows)
    // itemJson.description.push('<br />');

    this.addItem(itemJson);
    this.render();
    clientData.product.isSubscription ? this.showPlans(selectedPkg) : this.toggleAddons(selectedPkg);
  },
  removePackage: function removePackage() {
    // remove all add-ons previously selected
    this.items = [];
    this.render();
  },
  addAddon: function addAddon(id) {
    var _clientData$product$o, _selectedAddon$cart$n, _selectedAddon$cart, _selectedAddon$cart$d, _selectedAddon$cart2;
    var selectedAddon = clientData.product.options.filter(function (item) {
      return item.id === id;
    })[0];
    if (!selectedAddon && (_clientData$product$o = clientData.product.options) !== null && _clientData$product$o !== void 0 && _clientData$product$o.length) selectedAddon = clientData.product.options.filter(function (item) {
      return item.id === id;
    })[0];
    var itemJson = {
      type: 'addon',
      id: id,
      name: (_selectedAddon$cart$n = (_selectedAddon$cart = selectedAddon.cart) === null || _selectedAddon$cart === void 0 ? void 0 : _selectedAddon$cart.name) !== null && _selectedAddon$cart$n !== void 0 ? _selectedAddon$cart$n : selectedAddon.title,
      price: selectedAddon.price,
      description: [],
      disclaimer: !selectedAddon.isCustom && selectedAddon.disclaimer ? selectedAddon.disclaimer : null
    };
    if (selectedAddon.nonTaxableAmount) itemJson.nonTaxableAmount = selectedAddon.nonTaxableAmount;
    if (selectedAddon.nonTaxMutEx) itemJson.nonTaxMutEx = selectedAddon.nonTaxMutEx;
    if (selectedAddon.description instanceof Array) selectedAddon.description = selectedAddon.description[0].text;
    var description = (_selectedAddon$cart$d = (_selectedAddon$cart2 = selectedAddon.cart) === null || _selectedAddon$cart2 === void 0 ? void 0 : _selectedAddon$cart2.description) !== null && _selectedAddon$cart$d !== void 0 ? _selectedAddon$cart$d : selectedAddon.description;
    description = description.length > 110 ? description.substr(0, 107) + '...' : description;
    if (selectedAddon.basketTitle) itemJson.name = selectedAddon.basketTitle;
    if (selectedAddon.singleItemInBasketWarning) itemJson.basketWarning = selectedAddon.singleItemInBasketWarning;
    itemJson.description.push('<div class="ellipsis-line-2 text-sm mb-1" style="line-height: 22px;" data-toggle="tooltip" title="' + selectedAddon.description + '">' + description + '</div>');
    this.addItem(itemJson);
    this.render();
  },
  addBundle: function addBundle(id, plan) {
    var selectedBundle = clientData.product.bundles.subscriptions.filter(function (item) {
      return item.id === id;
    })[0];
    var selectedPlan = selectedBundle.stripe.plans.filter(function (item) {
      return item.id === plan;
    })[0];
    var itemJson = {
      type: 'bundle',
      id: id,
      plan: plan,
      name: selectedBundle.title + ' - ' + selectedPlan.id.capitalizeFirstLetter(),
      price: selectedPlan.price,
      description: [],
      disclaimer: selectedBundle.disclaimer ? selectedBundle.disclaimer : null
    };
    var description = selectedBundle.description.length > 140 ? selectedBundle.description.substr(0, 137) + '...' : selectedBundle.description;
    itemJson.description.push('<div class="text-sm mb-1" style="line-height: 22px;" data-toggle="tooltip" title="' + selectedBundle.description + '">' + description + '</div>');
    this.addItem(itemJson);
    this.render();
  },
  removeAddon: function removeAddon(id) {
    if (this.isItemInCart(id)) this.removeItem(id);
    this.render();
  },
  removeBundle: function removeBundle(id) {
    if (this.isItemInCart(id)) this.removeItem(id);
    this.render();
  },
  removeBundles: function removeBundles() {
    LSCart.items = LSCart.items.filter(function (item) {
      return item.type !== 'bundle';
    });
    this.render();
  },
  isItemInCart: function isItemInCart(id) {
    for (var i = 0; i < this.items.length; i++) if (this.items[i].id === id) return true;
    return false;
  },
  isItemParentInCart: function isItemParentInCart(id) {
    for (var i = 0; i < this.items.length; i++) if (this.items[i].parent === id) return true;
    return false;
  },
  addPlan: function addPlan(selectedPkg, planId) {
    var _selectedPkg$title;
    LSCart.removePlan();
    var plans = selectedPkg !== null && selectedPkg !== void 0 && selectedPkg.stripe ? selectedPkg.stripe.plans : clientData.product.stripe.plans;
    var selectedPlan = plans.filter(function (item) {
      return item.id === planId;
    })[0];
    var itemJson = {
      type: 'plan',
      id: planId,
      name: (_selectedPkg$title = selectedPkg.title) !== null && _selectedPkg$title !== void 0 ? _selectedPkg$title : selectedPkg.name,
      price: selectedPlan.price,
      parent: selectedPkg.id,
      description: [],
      disclaimer: selectedPkg.disclaimer ? selectedPkg.disclaimer : null
    };
    if (selectedPkg.description instanceof Array) selectedPkg.description = selectedPkg.description[0].text;
    var description = selectedPkg.description.length > 110 ? selectedPkg.description.substr(0, 107) + '...' : selectedPkg.description;
    if (selectedPkg.basketTitle) itemJson.name = selectedPkg.basketTitle;
    if (selectedPkg.singleItemInBasketWarning) itemJson.basketWarning = selectedPkg.singleItemInBasketWarning;
    itemJson.description.push('<div class="text-sm mb-1" style="line-height: 22px;" data-toggle="tooltip" title="' + selectedPkg.description + '">' + description + '</div>');
    this.addItem(itemJson);
    this.render();
  },
  removePlan: function removePlan() {
    var i = 0;
    for (; i < LSCart.items.length; i++) if (LSCart.items[i].type === 'plan') break;
    LSCart.items.splice(i, 1);
    LSCart.render();
  },
  showPlans: function showPlans(selectedPkg) {
    var $plans = $('.container-plans');
    var $tpl = $('.template-add-on .card');
    var plans = selectedPkg !== null && selectedPkg !== void 0 && selectedPkg.stripe ? selectedPkg.stripe.plans : clientData.product.stripe.plans;
    $plans.empty();
    $('.plans-title').html('<div style="line-height: 22px;">' + '   <span class="bold text-md">Select A Virtual Office Address Plan:</span><br />' + '   Pay Annually & get 4 months FREE | That’s a saving of £60.00 a year!' + '</div>');
    var _iterator4 = _createForOfIteratorHelper(plans),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var plan = _step4.value;
        (function (plan) {
          var $plan = $('<div class="col-sm-6"></div>').append($($tpl.clone()));
          $('.price', $plan).html(plan.price);
          $('[data-option-id]', $plan).attr('data-option-id', plan.id);
          $('.title', $plan).html(plan.id.toUpperCase());
          $('.description', $plan).html(plan.description);
          if (plan.isPopular) {
            $('.text-pill-success', $plan).html(plan.isPopular);
            $('.text-pill-success', $plan).show();
          }
          var onSelectClick = function onSelectClick(selectedPkg, plan, $plan) {
            LSCheckout.onAddPlanClick(selectedPkg, plan.id);
            $('.container-plans a').show();
            $('.container-plans .selected').hide();
            $('.container-plans .card').addClass('bg-gray');
            var optionId = $('a', $plan).attr('data-option-id');
            var $plans = $('[data-option-id="' + optionId + '"]').closest('.col-sm-6');
            $('a', $plans).hide();
            $('.selected', $plans).show();
            $('.card', $plans).removeClass('bg-gray');
          };
          $('a', $plan).click(function () {
            onSelectClick(selectedPkg, plan, $plan);
            return false;
          });
          $plans.append($plan);
          if (plan.isSelected) onSelectClick(selectedPkg, plan, $plan);
        })(plan);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  },
  toggleAddons: function toggleAddons(selectedPkg) {
    var _this$items$filter, _this$items3;
    if ($('.custom-addons-list').length) {
      $('.container-add-ons .card-container').show();
      selectedPkg.options.forEach(function (id) {
        $('[data-option-id="' + id + '"]').closest('.card-container').hide();
      });
    } else {
      $('.container-add-ons .card').show();
      selectedPkg.options.forEach(function (id) {
        $('[data-option-id="' + id + '"]').closest('.card').hide();
      });
    }
    var addonSelected = (_this$items$filter = (_this$items3 = this.items) === null || _this$items3 === void 0 ? void 0 : _this$items3.filter(function (item) {
      return item.type === "addon";
    })) !== null && _this$items$filter !== void 0 ? _this$items$filter : 0;
    if (selectedPkg.options.length >= addonSelected.length) $('.container-add-ons .no-res').hide();else $('.container-add-ons .no-res').show();
  },
  getOptionIds: function getOptionIds() {
    var res = [];
    this.items.forEach(function (i) {
      if (i.type === 'addon') res.push(i.id);
      if (i.type === 'plan' && i.parent) res.push(i.parent);
    });
    return res;
  },
  getPackageId: function getPackageId() {
    var _this$items$;
    if (((_this$items$ = this.items[0]) === null || _this$items$ === void 0 ? void 0 : _this$items$.type) === 'package') {
      return this.items[0].id;
    }
    return null;
  },
  getAddonPlanId: function getAddonPlanId() {
    var _iterator5 = _createForOfIteratorHelper(this.items),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var i = _step5.value;
        if (i.type === 'plan') {
          return i.id;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    return null;
  },
  toggleGoToCheckoutOrDashboardBtn: function toggleGoToCheckoutOrDashboardBtn() {
    if (this.total === 0 && clientData.page.isFreeCartAllowed) {
      $('.container-btn-dashboard').show();
      $('#cart .btn-continue').hide();
      $('.fixed-cart:visible .btn-continue').hide();
      this.isFreeCartAllowed = true;
    } else {
      $('.container-btn-dashboard').hide();
      $('#cart .btn-continue').show();
      this.isFreeCartAllowed = false;
    }
  }
};
export { LSCart };